import { H3 } from "melodies-source/Text";
import { NoData, ReportMetricCard } from ".";
import { PieChart } from "Components/PieChart";
import { useIsMobile } from "melodies-source/utils";
import { useTheme } from "styled-components";

interface TopSourcesProps {
  sources?: any;
}

export const TopSources = ({ sources, ...props }: TopSourcesProps) => {
  const isMobile = useIsMobile();
  const theme = useTheme();
  return (
    <ReportMetricCard isElevated {...props}>
      <H3>Top Sources</H3>
      {sources?.length ? (
        <PieChart
          dataKey="visits"
          nameKey="label"
          data={sources}
          layout={isMobile ? "vertical" : "horizontal"}
          colors={theme.custom?.charts?.donut.colors}
        />
      ) : (
        <NoData />
      )}
    </ReportMetricCard>
  );
};
